import moment from 'moment';

const dateToMoment = (timestamp) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  const messageDate = moment(date);
  return messageDate.calendar(null, {
    lastDay: '[Ayer]',
    sameDay: 'HH:mm',
    // nextDay: '[Tomorrow]',
    lastWeek: 'D/M',
    // nextWeek: 'dddd',
    sameElse: 'D/M',
  });
};

export default dateToMoment;
